import { render } from "./ViewGridIcon.vue?vue&type=template&id=f7ce4b60"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__